import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

import { useRemovePage } from '../../../../api';
import { InstPage, Platform, TgPage } from '../../../../types';

import { ConfirmModal } from '@/components/Modals/Confirm';

type RemoveButtonProps = {
  platform: Platform;
  page: TgPage | InstPage;
};

export const RemoveButton = ({ platform, page }: RemoveButtonProps) => {
  const removePage = useRemovePage();

  return (
    <Tooltip label="Remove Page">
      <ActionIcon
        variant="filled"
        color="red"
        onClick={() =>
          NiceModal.show(ConfirmModal, {
            title: `Remove page (${page.name})?`,
            onSuccess: () => removePage.mutate({ pageId: page._id, platform }),
          })
        }
        radius="md"
      >
        <IconTrash />
      </ActionIcon>
    </Tooltip>
  );
};
